export const FONTS = [
    "Custom Store Font",
    "Inter",
    "Tiny5",
    "Gwendolyn",
    "Lato",
    "Roboto",
    "Josefin Sans",
    "Lobster",
    "Open Sans",
    "Poiret One",
    "Dancing Script",
    "Bangers",
    "Playfair Display",
    "Chewy",
    "Quicksand",
    "Great Vibes",
    "Righteous",
    "Montserrat",
    "Oswald",
    "Unica One",
    "Muli",
    "Raleway",
    "Carter One",
    "Varela Round",
    "Julius Sans One",
    "Helvetica",
    "Verdana",
    "Courier",
    "Times New Roman",
    "Georgia",
    "Serif",
    "Kalam",
];

export const injectFonts = (fonts: Array<string>) => {
    fonts.forEach((font) => {
        if (font != "Custom Store Font") {
            const link = document.createElement("link");
            link.setAttribute(
                "href",
                `https://fonts.googleapis.com/css2?family=${font
                    .split(" ")
                    .join("+")}`,
            );
            link.setAttribute("rel", "stylesheet");
            document.head.appendChild(link);
        }
    });
};
